import React, { createContext, useContext, FunctionComponent, ReactNode, useState } from 'react';

import { PeopleManagementFilterType } from './PeopleManagementFilter';

export interface PeopleManagementState {
  search: string;
  filter: PeopleManagementFilterType;
  sort: string;
}

interface PeopleManagementContextType {
  state: PeopleManagementState;
  updateSearch: (search: string) => void;
  updateFilter: (filter: PeopleManagementFilterType) => void;
  updateSort: (sort: string) => void;
}

const PeopleManagementContext = createContext<PeopleManagementContextType | undefined>(undefined);

interface PeopleManagementProviderProps {
  children: ReactNode;
}

export const PeopleManagementProvider: FunctionComponent<PeopleManagementProviderProps> = ({
  children,
}) => {
  const [state, setState] = useState<PeopleManagementState>({
    search: '',
    filter: 'all',
    sort: 'name_asc',
  });

  const updateSearch = (search: string): void => {
    setState((prev) => ({ ...prev, search }));
  };

  const updateFilter = (filter: PeopleManagementFilterType): void => {
    setState((prev) => ({ ...prev, filter }));
  };

  const updateSort = (sort: string): void => {
    setState((prev) => ({ ...prev, sort }));
  };

  const contextValue: PeopleManagementContextType = {
    state,
    updateSearch,
    updateFilter,
    updateSort,
  };

  return (
    <PeopleManagementContext.Provider value={contextValue}>
      {children}
    </PeopleManagementContext.Provider>
  );
};

export const usePeopleManagementContext = (): PeopleManagementContextType => {
  const context = useContext(PeopleManagementContext);
  if (!context) {
    throw new Error('usePeopleManagementContext must be used within a PeopleManagementProvider');
  }
  return context;
};
